import { render, staticRenderFns } from "./DSimpleRadioPreview.vue?vue&type=template&id=30da4813&"
import script from "./DSimpleRadioPreview.vue?vue&type=script&lang=js&"
export * from "./DSimpleRadioPreview.vue?vue&type=script&lang=js&"
import style0 from "./DSimpleRadioPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports